export default __webpack_public_path__ + "static/media/avatar17.988dff53.png";